export function isValidAddress1(addressLine1) {
  return addressLine1 ? (addressLine1.length > 0 || "Address Line 1 is required") : "Address Line 1 is required"
}

export const rules = [isValidAddress1]
